<template>
  <form-item-label label="転職希望時期" :required="true" />
  <complemented-text-form
    v-if="complementedTextOpened"
    :text="complementedText"
    @open="openForm"
    :editable="true"
    :colspan="1"
  />
  <td v-if="!complementedTextOpened">
    <div
      class="m3p-contact__timing"
      :class="shouldDisplayError ? [`m3p-form__errorbox`] : null"
    >
      <selector-field
        class="m3p-select m3p-form__strong"
        :name="fieldName"
        :id="fieldName"
        :options="selectiveWishfulTimeList"
        :validator="validator"
        :dispatcher="dispatcher"
      >
        <template #select="props">
          <option :value="null" disabled>選択してください</option>
          <option
            v-for="item in props.options"
            :value="item.value"
            :key="item.value"
            >{{ item.text }}</option
          >
        </template>
      </selector-field>
      <error-message :name="fieldName" />
    </div>
  </td>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useFieldError } from 'vee-validate';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import SelectorField from '@component_path/pages/common/form/element/select';
import { useWishfulTimeField } from '@component_path/inquiry_form_common_module/custom_hook/WishfulTime';

const store = useStore();

const props = defineProps({
  wishfulTimeMaster: {
    type: Array,
    required: true
  }
});

const { validator, fieldName } = useWishfulTimeField(true);
const dispatcher = ref('positionInquiryMail/setWishfulTime');
const shouldDisplayError = useFieldError(fieldName.value);

const complementedTextOpened = ref(false);

const wishfulTime = computed(
  () => store.state.positionInquiryMail.formData.wishful_time
);
const selectiveWishfulTimeList = computed(() => {
  return props.wishfulTimeMaster.map(wishfulTime => ({
    value: Number(wishfulTime.code),
    text: wishfulTime.name
  }));
});

const complementedText = computed(() => {
  const selectedWishfulTime = selectiveWishfulTimeList.value.find(
    item => item.value === wishfulTime.value
  );
  return selectedWishfulTime ? selectedWishfulTime.text : '';
});
const openForm = () => (complementedTextOpened.value = false);

onMounted(() => {
  if (wishfulTime.value !== undefined && wishfulTime.value !== null) {
    complementedTextOpened.value = true;
  }
});
</script>
